import Spinner from "react-bootstrap/Spinner";

function Loader() {
  return (
    <Spinner animation="border" role="status" className="project-text-color" />
  );
}

export default Loader;
